import { Component, Prop, Vue } from 'vue-property-decorator'
import { MasterlinkRoleServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'
import { billSettings } from '@/utils/commonDef'
import '../index.less'

const masterlinkService = new MasterlinkRoleServiceProxy()

@Component
export default class LeftTree extends Vue {
  @Prop() menuId: string
  @Prop({default: 'bill-setting'}) page: string
  selectKeys = []
  treeData = []
  firstSelected = false
  selectedKeys = []
  expandedKeys = []

  mounted() {
    this.$nextTick(() => {
      this.getList()
    })

  }

  getList() {
    this.treeData = []
    let temp = []
    this.firstSelected = false
    masterlinkService.getAvailableDynamicMenus(this.menuId).then(res => {
      // if(res.data && res.data.length > 0){
      // let authMenus = res.data.filter(item=> billSettings.includes(item.attribute.code))
      // let temp = this.arrayToTree(authMenus)
      if (res.data) {
        let authMenus = res.data.treeNodes
        if (this.page === 'bill-setting') {
          authMenus = res.data.treeNodes.filter(item => billSettings.includes(item.attribute.code))
        }
        authMenus.forEach(element => {
          temp.push(this.treeNode(element))
        })
        this.treeData = temp
      }
    })
  }

  arrayToTree(data) {
    let ids = data.map(item => (item.id))
    let obj = {}
    let deleteObjIds = []
    ids.map(id => {
      obj[id] = []
      data.map((item,index,arr) => {
        if (item.parentId === id) {
          obj[id].push(item)
          deleteObjIds.push(item.id)
        }
      })
    })
    const changeData = (data2) =>{
      data2.map(item=>{
        item.children = obj[item.id]
        if(item.children.length) {
          changeData(item.children)
        }
      })
    }
    changeData(data)
    data.slice(0).reverse().map((item,index,arr) => {
      if(deleteObjIds.includes(item.id)) {
        data.splice(arr.length - index - 1, 1)
      }
    })

    return data
  }

  treeNode(value){
    console.log(123,value)
    const bizCode = this.getBizCode(value.attribute)
    const attribute = value.attribute
    const node = {
      title: attribute.code ? attribute.code : '',
      key: value.key,
      children: value.children,
      bizCode: bizCode.bizcode,
      dataId: bizCode.dataid,
      scopedSlots: { title: 'custom' }
    }
    if(this.page==='fieldSetting') {
      if((!value.children || !value.children.length) && !this.firstSelected) {
        this.firstSelected = true
        this.selectedKeys = [node.key]
        this.$emit('change', node)
      }
    }
    if(bizCode.bizcode !== '' && !this.firstSelected){
      this.firstSelected = true
      this.selectedKeys = [node.key]
      this.$emit('change', node)
    }
    if(value.children && value.children.length > 0){
      this.expandedKeys.push(value.key)
      for(let i = 0; i < value.children.length; i++){
        node.children[i] = this.treeNode(value.children[i])
      }
    }
    return node
  }

  getBizCode(value){
    let code = {
      bizcode: '',
      dataid: ''
    }
    if (!value.path) {
      return code
    }
    if(value.path.indexOf('?bizCode=') !== -1){
      const codelength = value.path.indexOf('?bizCode=') + 9
      if(value.path.indexOf('&dataId=') !== -1){
        const idlength = value.path.indexOf('?dataId=')
        code.bizcode = value.path.substring(codelength,idlength)
        code.dataid = value.path.substring(idlength + 8)
      } else {
        code.bizcode = value.path.substring(codelength)
      }
    }
    return code
  }

  selectd(selectedKeys,selectedRows) {
    console.log('selectRows:', selectedRows)
    if (this.page === 'fieldSetting' && selectedRows.selected) { // 字段设置页面
      if (selectedRows.node.dataRef.children.length) { // 父层级无法选中
        if (this.expandedKeys.indexOf(selectedKeys[0]) !== -1) {
          this.expandedKeys.splice(this.expandedKeys.indexOf(selectedKeys[0]), 1)
        } else {
          this.expandedKeys.push(selectedKeys[0])
        }
      } else { // 点击最子层级触发选中
        this.selectedKeys = selectedKeys
        this.$emit('change', selectedRows.node.dataRef)
      }

    } else {
      if (selectedRows.node.dataRef.bizCode !== '' && selectedRows.selected) {
        this.selectedKeys = selectedKeys
        this.$emit('change', selectedRows.node.dataRef)
      } else {
        if (this.expandedKeys.indexOf(selectedKeys[0]) !== -1) {
          this.expandedKeys.splice(this.expandedKeys.indexOf(selectedKeys[0]), 1)
        } else {
          this.expandedKeys.push(selectedKeys[0])
        }
      }
    }
  }

  onExpended(expandedKeys){
    this.expandedKeys = expandedKeys
  }

  render() {
    return (
      <a-tree
        showLine={true}
        showIcon={true}
        blockNode
        expandedKeys={this.expandedKeys}
        selectedKeys={this.selectedKeys}
        treeData={this.treeData}
        onExpand={(expandedKeys) => this.onExpended(expandedKeys)}
        onSelect={(selectedKeys,selectedRows) => this.selectd(selectedKeys,selectedRows)}
        scopedSlots={{
          custom: context => (
            (this.$t(context.title))
          )
        }}
      >
      </a-tree>
    )
  }
}

